import { useQuery } from "@tanstack/react-query";
import { contractorApi } from "../api/contractorApi";

export const useFetchContractor = () => {

    const { data, isFetching, isPending, isError, error, refetch } = useQuery({
        queryKey: ["contractors"],
        queryFn: () => contractorApi.fetchCards(),
    });

    return {
        data,
        isLoading: isFetching || isPending,
        isError,
        error,
        refetch,
    };

};
